// apiService.js
import axios from 'axios';
import { getToken, TokenExpired, refreshToken } from './authService';

const backendUrl = process.env.NODE_ENV === 'production'
  ? process.env.REACT_APP_BACKEND_URL
  : 'http://localhost:8080';
const api = axios.create({
  baseURL: `${backendUrl}`
});

api.interceptors.request.use(
  async (config) => {
    let token = getToken();

    if (TokenExpired()) {
      token = await refreshToken();
      if (!token) {
        // Optionally redirect to login if refresh fails
        window.location.href = '/login';
        return Promise.reject('Token expired and refresh failed');
      }
    }

    config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

export default api;
